import {
  Action,
  ActionType,
  IConsultationCSVResponse,
} from "models/consultations/downloadConsultationCSV";
import createReducer from "redux/createReducer";

export interface DownloadConsultationCSVReducerType {
  loading: boolean;
  error?: string;
  downloadConsultationCSVResponse?: IConsultationCSVResponse;
}

const defaultState: DownloadConsultationCSVReducerType = {
  loading: false,
  error: undefined,
  downloadConsultationCSVResponse: undefined,
};

export const downloadConsultationCSVReducer =
  createReducer<DownloadConsultationCSVReducerType>(defaultState, {
    [ActionType.DOWNLOAD_CONSULTATION_CSV](
      state: DownloadConsultationCSVReducerType
    ) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.DOWNLOAD_CONSULTATION_CSV_ERROR](
      state: DownloadConsultationCSVReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
        downloadConsultationCSVResponse: undefined,
      };
    },

    [ActionType.DOWNLOAD_CONSULTATION_CSV_SUCCESS](
      state: DownloadConsultationCSVReducerType,
      action: Action<number>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        downloadConsultationCSVResponse: action.payload,
      };
    },

    [ActionType.DOWNLOAD_CONSULTATION_CSV_RESET](
      state: DownloadConsultationCSVReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        downloadConsultationCSVResponse: undefined,
      };
    },
  });
